import type { FC } from "react";
import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import { AutoRenewalDeactivationCondition } from "~/generated/graphql";
import type { MembershipWithInstallmentsDisclaimerProps } from "./contract";

const MembershipWithInstallmentsDisclaimer: FC<
  MembershipWithInstallmentsDisclaimerProps
> = ({ autoRenewalPolicy }) => {
  const { t } = useTranslation();
  const disclaimersMap = {
    [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_12ConsecutiveMonthlyRenewals]:
      "membershipWithInstallmentsDisclaimer.yearlyPaidMonthly",
  };
  if (!autoRenewalPolicy) return null;
  return <>{t(`${disclaimersMap[autoRenewalPolicy]}`)}</>;
};

export default MembershipWithInstallmentsDisclaimer;
